import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useConvertDataFromISOString } from 'features/call/vrs-call-comments/hooks';
import theme from 'features/theme/theme';

export const VrsCallCommentsBugReportCallTakenTime = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'bugReport',
  });
  const formattedDateTime = useConvertDataFromISOString();

  return (
    <>
      <Typography variant='label' color={theme.palette.grey[100]} mt={6}>
        {t('dateTimeTitle')}
      </Typography>
      <Typography variant='body1' color={theme.palette.common.white}>
        {formattedDateTime}
      </Typography>
    </>
  );
};
